import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/comics';

export default function FaqSection() {
  const faqSchemaData = {
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question' as const,
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer' as const,
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <div className="relative w-full h-48 md:h-56 rounded-2xl overflow-hidden border border-background-200/30">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20cozy%20reading%20scene%20with%20warm%20ambient%20lighting%2C%20person%20reading%20comics%20on%20device%2C%20comfortable%20atmosphere%2C%20soft%20orange%20glow%2C%20anime%20art%20style%2C%20cinematic%20composition%2C%20dark%20moody%20background%20with%20film%20grain%20texture&width=1600&height=400&seq=faq-banner&orientation=landscape"
              alt="韩漫屋常见问题"
              title="韩漫屋 - 常见问题解答"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-background-950/50"></div>
          </div>
        </div>

        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-50 leading-tight mb-4">
            关于 <span className="text-primary-500 italic">韩漫屋</span> 的
            <br />
            常见问题
          </h2>
          <p className="text-sm text-foreground-400 max-w-md mx-auto">
            这里有您想了解的一切。如果还有疑问，欢迎随时联系我们。
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-100 rounded-xl border border-background-200/30 overflow-hidden transition-all duration-200"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-200 pr-4">{faq.question}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 transition-transform duration-200 group-open:rotate-180">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold bg-background-100 text-foreground-200 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-primary-500 hover:text-background-950 cursor-pointer border border-background-200/30"
          >
            了解更多关于韩漫屋
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqSchemaData.mainEntity,
          }),
        }}
      />
    </section>
  );
}